
import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import Layout from '@/components/layout/Layout';
import AwardMemberSearch from '@/components/musicians/AwardMemberSearch';
import { Award, Info } from 'lucide-react';

const AwardNetworking: React.FC = () => {
  return (
    <Layout>
      <div className="container max-w-7xl pt-8 pb-16">
        <div className="flex flex-col gap-2 mb-8">
          <h1 className="text-3xl font-bold tracking-tight">Award Networking</h1>
          <p className="text-muted-foreground">
            Connect with award voting members and boost your campaign strategy
          </p>
        </div>

        <Card className="mb-8 border-2 border-yellow-200 bg-yellow-50 dark:bg-yellow-950/20 dark:border-yellow-900">
          <CardContent className="py-4">
            <div className="flex items-start gap-2">
              <Info className="h-5 w-5 text-yellow-600 dark:text-yellow-500 mt-0.5" />
              <div>
                <h4 className="font-semibold">Award Networking Feature</h4>
                <p className="text-sm text-yellow-700 dark:text-yellow-400">
                  This feature allows artists to discover and connect with voting members of major music awards.
                  Add your own voting memberships in your profile to be discovered by other artists.
                </p>
              </div>
            </div>
          </CardContent>
        </Card>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          <div className="lg:col-span-2">
            <AwardMemberSearch />
          </div>
          
          <div>
            <Card>
              <CardHeader>
                <CardTitle className="flex items-center gap-2">
                  <Award className="h-5 w-5" />
                  <span>Award Campaign Tips</span>
                </CardTitle>
                <CardDescription>
                  Best practices for connecting with voting members
                </CardDescription>
              </CardHeader>
              <CardContent className="space-y-4">
                <div>
                  <h4 className="font-medium">Be Respectful of Their Time</h4>
                  <p className="text-sm text-muted-foreground">
                    Keep communications concise and to the point. Respect that voting members receive many requests.
                  </p>
                </div>
                
                <div>
                  <h4 className="font-medium">Focus on Your Work</h4>
                  <p className="text-sm text-muted-foreground">
                    Highlight what makes your music award-worthy rather than just asking for votes.
                  </p>
                </div>
                
                <div>
                  <h4 className="font-medium">Build Genuine Connections</h4>
                  <p className="text-sm text-muted-foreground">
                    Focus on building long-term relationships rather than transactional interactions.
                  </p>
                </div>
                
                <div>
                  <h4 className="font-medium">Be Specific</h4>
                  <p className="text-sm text-muted-foreground">
                    Mention the specific categories you're interested in and why your work fits those categories.
                  </p>
                </div>
                
                <div>
                  <h4 className="font-medium">Follow Award Guidelines</h4>
                  <p className="text-sm text-muted-foreground">
                    Ensure your outreach complies with the award organization's rules for campaigning.
                  </p>
                </div>
              </CardContent>
            </Card>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default AwardNetworking;
